import {createApp} from "vue";
import VueFullScreen from "vue-fullscreen"
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';
import MultiplyGame from './games/multiply/MultiplyGame.vue'
import AdditionGame from './games/addition/AdditionGame.vue'
import XoxGame from './games/xox/XoxGame.vue'
import ElementsGame from './games/elements/ElementsGame.vue'
import IslemTahminGame from './games/islem_tahmin/IslemTahminGame.vue'
import HedefSayiBulalimGame from './games/hedef_sayi_bulalim/HedefSayiBulalimGame.vue'

i18next
    .init({
        lng: 'tr',
        fallbackLng: 'en',
        resources: {tr: {}, en: {}},
        nonExplicitSupportedLngs: false,
        cleanCode: true
    });

if (document.getElementById('multiply-game-container')) {
    createApp({
        components: {MultiplyGame}
    })
        .use(I18NextVue, {i18next})
        .use(VueFullScreen, {name: "fs"})
        .mount('#multiply-game-container');
}

if (document.getElementById('addition-game-container')) {
    createApp({
        components: {AdditionGame}
    })
        .use(I18NextVue, {i18next})
        .use(VueFullScreen, {name: "fs"})
        .mount('#addition-game-container');
}

if (document.getElementById('xox-game-container')) {
    createApp({
        components: {XoxGame}
    })
        .use(I18NextVue, {i18next})
        .use(VueFullScreen, {name: "fs"})
        .mount('#xox-game-container');
}

if (document.getElementById('element-game-container')) {
    createApp({
        components: {ElementsGame}
    })
        .use(I18NextVue, {i18next})
        .use(VueFullScreen, {name: "fs"})
        .mount('#element-game-container');
}

if (document.getElementById('islem-tahmin-game-container')) {
    createApp({
        components: {IslemTahminGame}
    })
        .use(I18NextVue, {i18next})
        .use(VueFullScreen, {name: "fs"})
        .mount('#islem-tahmin-game-container');
}

if (document.getElementById('hedef-sayi-bulalim-game-container')) {
    createApp({
        components: {HedefSayiBulalimGame}
    })
        .use(I18NextVue, {i18next})
        .use(VueFullScreen, {name: "fs"})
        .mount('#hedef-sayi-bulalim-game-container');
}

document.addEventListener('contextmenu', (event) => {
    event.preventDefault();
})
